import { render, staticRenderFns } from "./prize_no.vue?vue&type=template&id=e59add00&scoped=true&"
import script from "./prize_no.vue?vue&type=script&lang=js&"
export * from "./prize_no.vue?vue&type=script&lang=js&"
import style0 from "./prize_no.vue?vue&type=style&index=0&id=e59add00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59add00",
  null
  
)

export default component.exports